import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Box, Typography, Divider, Paper, Grid, Avatar, Chip, Card, CardHeader, CardContent, Rating
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { red } from '@mui/material/colors';
import DoneIcon from '@mui/icons-material/Done';
import LibrarySelect from 'components/librarySelect';
import { Stack } from '@mui/system';
import { getPropertyReviewsByIdAndType } from 'services/property';
import { getDisplayDate } from '../../services/commonServices';

const GuestReview = () => {

  const ratingsList = useMemo(() => [
    {label: 'All', value: -1},
    {label: '0-1 Star', value: 1},
    {label: '1-2 Star', value: 2},
    {label: '2-3 Star', value: 3},
    {label: '3-4 Star', value: 4},
    {label: '4-5 Star', value: 5},
  ], []);

  const { enqueueSnackbar } = useSnackbar();
  const [librarySelected, setLibraySelected] = useState({});
  const [rating, setRating] = useState(ratingsList[0]);
  const [reviewsData, setReviewsData] = useState([]);

  const onLibrarySelected = useCallback((lib) => setLibraySelected(lib),[]);

  const getReviews = useCallback((library) => {

    const data = {
      propertyId: library?.libraryId,
      propertyType: "LIBRARY",
    };

    getPropertyReviewsByIdAndType({
      ...data,
    }).then(({response, error}) => {
      if(response){
        setReviewsData([...response]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);

  useEffect(() => {
    if(librarySelected?.libraryId){
      getReviews(librarySelected);
    }
  }, [librarySelected, getReviews]);

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Guest Reviews
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2, mb: 4 }} >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            <Paper sx={{boxShadow: "rgb(58, 53, 65, 0.1) 0px 2px 10px 0px", p: 2, backgroundColor: '#f7f7f7'}}>
              <Stack direction="row" sx={{flexWrap: 'wrap'}} rowGap={2}>
                <LibrarySelect width={240} onLibrarySelected={onLibrarySelected}/>
                <Divider sx={{ height: 28, my: 0.5, mx: 1.5, display:{xs: 'none', sm: 'block'} }} orientation="vertical" />
                {ratingsList.map((val,index) => (
                  <Chip 
                    key={index} 
                    color={(rating.value === val.value) ? 'primary':'default'} 
                    icon={(rating.value === val.value) ? <DoneIcon /> : null}
                    label={val.label} 
                    sx={{mx: 1, mb: '0.8rem'}} 
                    onClick={()=> setRating(val)}
                  />
                ))}
              </Stack>
            </Paper>
          </Grid>
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} rowSpacing={3} columnSpacing={2}>
            {reviewsData.filter((val) => {
              if(rating?.value === -1){
                return true;
              }else if(val?.rating <= rating?.value && val?.rating >= rating?.value-1){
                return true
              }else{
                return false;
              }
            }).map((value, index) => (
              <Grid key={index} item xs={12} sm={12} md={6} xl={3} lg={4}>
                <Card sx={{height: '100%' }}>
                  <CardHeader
                    avatar={
                      <Avatar
                        sx={{ bgcolor: red[500] }}
                        aria-label={(value?.reviewerName || '')}
                        alt={(value?.reviewerName || '')}
                        src={`/vendor/rest/properties/getProfilePhotoByUserId?userId=${value?.userId}`}
                      />
                    }
                    title={value?.reviewerName}
                    subheader={getDisplayDate(value?.reviewDate)}
                  />
                  <Rating value={value?.rating} sx={{ml: '1rem'}}/>
                  <CardContent sx={{pt: 1}}>
                    <Typography variant="body2" color="text.secondary">{value?.review}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default GuestReview;
